import useChangeColors from "@/hooks/useChangeColors"
import { Alert } from "@/types/types"
import { formatPercentage } from "@/utils/format"
import clsx from "clsx"

type AlertMeterProps = {
  threshold: Alert["change_threshold"]
  change: Alert["change"]
  highlightThreshold?: boolean
}

const AlertMeter = ({
  threshold,
  change,
  highlightThreshold = false,
}: AlertMeterProps) => {
  const { textColor, bgColor } = useChangeColors(change)
  const progress = Math.min(Math.abs((change / threshold) * 100), 100)

  return (
    <div className="text-xs text-gray-600">
      <div className="relative h-0.5 w-full rounded-full bg-gray-700">
        <div
          className={`absolute top-0 left-0 h-0.5 rounded-full ${bgColor}`}
          style={{ width: `${progress}%` }}
        />
        <div
          className={clsx(
            "absolute top-0 -translate-y-full transform",
            progress > 15 && "-translate-x-full",
            textColor
          )}
          style={{ left: progress > 15 ? `${progress}%` : 0 }}
        >
          {formatPercentage(change)}
        </div>
        <div className="absolute bottom-0 -mb-px flex w-full translate-y-full transform justify-between">
          <div>0%</div>
          <div className={highlightThreshold ? "text-teal-300" : undefined}>
            {formatPercentage(threshold)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AlertMeter
